import React from "react";
import { BasicSelect, CardShell, FieldLabel } from "./card-handler";

interface FetchCurrentDateCardProps {
  config: Record<string, any>;
  onUpdate: (config: Record<string, any>) => void;
  onDelete: () => void;
  onReset: () => void;
  bare?: boolean;
}

export const FetchCurrentDateCard: React.FC<FetchCurrentDateCardProps> = ({
  config,
  onUpdate,
  onDelete,
  onReset,
  bare,
}) => {
  const update = (patch: Record<string, any>) => onUpdate({ ...config, ...patch });

  return (
    <CardShell
      title="Fetch Current Date"
      description="Fetches current date to identify birthdays"
      onDelete={onDelete}
      onReset={onReset}
      bare={bare}
    >
        <div className="mb-3">
          <FieldLabel>Date Source</FieldLabel>
          <BasicSelect
            value={config.dateSource ?? "current_date"}
            onChange={(value) => update({ dateSource: value })}
            options={[{ label: "Current Date", value: "current_date" }]}
          />
        </div>

        <div className="mb-3">
          <FieldLabel>Date Format</FieldLabel>
          <BasicSelect
            value={config.dateFormat ?? "dd-mm-yyyy"}
            onChange={(value) => update({ dateFormat: value })}
            options={[
              { label: "dd-mm-yyyy", value: "dd-mm-yyyy" },
              { label: "yyyy-mm-dd", value: "yyyy-mm-dd" },
              { label: "mm-dd-yyyy", value: "mm-dd-yyyy" },
            ]}
          />
        </div>

        <p className="text-xs text-[#7B7B7B] font-semibold dark:text-gray-500 leading-relaxed">
          Set the event to current date and choose the format used to check against uploaded birthday dates.
        </p>
    </CardShell>
  );
};